import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { UserModel } from '../../../../models/user.model';
import { AlertService } from '../../../../services/alert.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-about-lecturers',
  templateUrl: './lecturers.component.html',
  styleUrl: './lecturers.component.scss',
  standalone: false,
})
export class AboutLecturersComponent implements OnInit {
  public lecturers: UserModel[] = [];
  public loading = true;

  constructor(
    private userService: UserService,
    private alertService: AlertService
  ) {}

  public ngOnInit(): void {
    this.userService
      .getActiveLecturers()
      .pipe(take(1))
      .subscribe({
        next: lecturers => {
          this.lecturers = lecturers;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.alertService.showErrorAlert(
            'Die Dozierenden konnten nicht geladen werden.'
          );
        },
      });
  }
}
